import React from "react";
import Popper from "@mui/material/Popper";
import IconButton from "@mui/material/IconButton";
import { Button, ListItemButton, ListItemIcon, Tooltip } from "@mui/material";
import { useState } from "react";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "./ShortcutDialog.css";
const ShortcutDialog = () => {
  const [openShortcut, setOpenShortcut] = useState(false);
  const [anchorElement, setAnchorElement] = useState(null);

  const openShortCutDialog = (event) => {
    setOpenShortcut(!openShortcut);
    setAnchorElement(anchorElement ? null : event.currentTarget);
  };
  return (
    <>
      <ListItemButton>
        <ListItemIcon>
          <Tooltip title="help">
            <IconButton onClick={openShortCutDialog}>
              <HelpOutlineIcon sx={{ color: "white" }} fontSize="large" />
            </IconButton>
          </Tooltip>
        </ListItemIcon>
      </ListItemButton>

      <Popper id="shortcut-popups" open={openShortcut} anchorEl={anchorElement}>
        <Box sx={{ p: 2, border: "2px solid #000", backgroundColor: "white" }}>
          <h4>
            <u>{"ShortcutList"}</u>
          </h4>
          <Grid spacing={1}>
            <Grid item xs={12} md={6}>
              <li>{"Ctrl+S--" + "Save"}</li>
            </Grid>
            <Grid item xs={12} md={6}>
              <li>{"Ctrl+D--" + "Clear"}</li>
            </Grid>
            <Grid item xs={12} md={6}>
              <li>{"Ctrl+U--" + "Upload"}</li>
            </Grid>
            <Grid item xs={12} md={6}>
              <li>{"Ctrl+U--" + "Approve"}</li>
            </Grid>
            <Grid item xs={12} md={6}>
              <li>{"Ctrl+J-- " + "Download"}</li>
            </Grid>
            <Grid item xs={12} md={6}>
              <li>{"Ctrl+K--" + "Ok"}</li>
            </Grid>
            <Grid item xs={12} md={6}>
              <li>{"Ctrl+Y--" + "Yes"}</li>
            </Grid>
            <Grid item xs={12} md={6}>
              <li>{"Ctrl+Q--" + "Cancel"}</li>
            </Grid>
            <Grid item xs={12} md={6}>
              <li>{"Ctrl+Q-- " + "Close"}</li>
            </Grid>
            <Grid item xs={12} md={6}>
              <li>{"Ctrl+G--" + "Next"}</li>
            </Grid>
            <Grid item xs={12} md={6}>
              <li>{"Ctrl+E--" + "View"}</li>
            </Grid>
            <Grid item xs={12} md={6}>
              <li>{"Ctrl+M--" + "Modify"}</li>
            </Grid>
            <Grid item xs={12} md={6}>
              <li>{"Ctrl+B--" + "Delete"}</li>
            </Grid>
            <Grid item xs={12} md={6}>
              <li>{"Ctrl+F--" + "Detail"}</li>
            </Grid>
            <Grid item xs={12} md={6}>
              <li>{"Ctrl+F--" + "Go"}</li>
            </Grid>
            <Grid item xs={12} md={6}>
              <li>{"Ctrl+F--" + "Search"}</li>
            </Grid>
            <Grid item xs={12} md={6}>
              <li>{"Ctrl+H--" + "History"}</li>
            </Grid>
            <Grid item xs={12} md={6}>
              <li>{"Ctrl+I--" + "Today"}</li>
            </Grid>
            <Grid item xs={12} md={6}>
              <li>{"Ctrl+O--" + "Tomorrow"}</li>
            </Grid>
            <Grid item xs={12} md={6}>
              <li>{"Ctrl+P-" + " Yesterday"}</li>
            </Grid>
          </Grid>
          <Grid item xs={12} md={6}>
            <Button onClick={openShortCutDialog}>OK</Button>
          </Grid>
        </Box>
      </Popper>
    </>
  );
};
export default ShortcutDialog;
